const routes = [
  {
    api: 'Box',
    pathname: '/customer/api-box',
    content: [
      {
        parent: 'Customer',
        pathname: '/customer',
        children: [
          {
            name: 'Activate Box',
            pathname: '/customer-activate-box'
          },
          {
            name: 'Consolidate List of Packages',
            pathname: '/customer-consolidate-awb'
          },
          {
            name: 'End Consolidation',
            pathname: '/customer-end-consolidation'
          },
          {
            name: 'Get Info',
            pathname: '/customer-get-information'
          },
          {
            name: 'Get Shipments',
            pathname: '/customer-get-shipments'
          },
          {
            name: 'Login',
            pathname: '/customer-login'
          },
          {
            name: 'Register Info',
            pathname: '/customer-register-information'
          },
          {
            name: 'Registration',
            pathname: '/customer-registration'
          },
          {
            name: 'Release Packages with no invoice',
            pathname: '/customer-release-no-invoice-awb'
          },
          {
            name: 'Start Consolidation',
            pathname: '/customer-start-consolidation'
          },
          {
            name: 'Update Address Info',
            pathname: '/customer-update-address-info'
          },
          {
            name: 'Update Email',
            pathname: '/customer-update-email'
          },
          {
            name: 'Update Password',
            pathname: '/customer-update-password'
          },
          {
            name: 'Update Personal Info',
            pathname: '/customer-update-personal-info'
          },
          {
            name: 'Update Type',
            pathname: '/customer-update-type'
          },
          {
            name: 'Upload Invoice Data',
            pathname: '/customer-upload-invoice-data'
          },
          {
            name: 'Update Invoice File',
            pathname: '/customer-upload-invoice-file'
          }
        ]
      },
      {
        parent: 'Geographic',
        pathname: '/geographic',
        children: [
          {
            name: 'Countries',
            pathname: '/geographic-get-countries'
          },
          {
            name: 'States',
            pathname: '/geographic-get-states'
          },
          {
            name: 'Cities',
            pathname: '/geographic-get-cities'
          }
        ]
      },
      {
        parent: 'Partner',
        pathname: '/partner',
        children: [
          {
            name: 'Get Info',
            pathname: '/get-info'
          }
        ]
      },
      {
        parent: 'Shipment',
        pathname: '/shipment',
        children: [
          {
            name: 'Get Shipment Info',
            pathname: '/get-shipment-info'
          },
          {
            name: 'Get Shipment Tracking Info',
            pathname: '/get-tracking-info'
          },
          {
            name: 'Get Shipment Rate',
            pathname: '/get-shipment-rate'
          },
          {
            name: 'Search Family Products',
            pathname: '/search-family-products'
          }
        ]
      }
    ]
  },
  {
    api: 'API SkyPostal 1.0',
    pathname: '/customer/api-skypostal-current',
    content: [
      {
        parent: 'Geographic',
        pathname: '/geographic',
        children: [
          {
            name: 'COPA Countries',
            pathname: '/search-all-enabled-countries'
          },
          {
            name: 'States by Country Code',
            pathname: '/search-enabled-states-by-country-code'
          },
          {
            name: 'States by Country ISO',
            pathname: '/search-enabled-states-by-country-iso'
          },
          {
            name: 'Cities by State Code',
            pathname: '/search-enabled-cities-by-state-code'
          }
        ]
      },
      {
        parent: 'Manifest',
        pathname: '/manifest',
        children: [
          {
            name: 'Process Manifest',
            pathname: '/process-manifest'
          },
          {
            name: 'Manifest Status',
            pathname: '/search-manifest-status-by-manifest-number'
          }
        ]
      },
      // {
      //   parent: 'Others',
      //   pathname: '/others',
      //   children: [
      //     {
      //       name: 'Search Tracking',
      //       pathname: '/add-delivery-checkpoint-by-awb'
      //     }
      //   ]
      // },
      {
        parent: 'Shipment',
        pathname: '/shipment',
        children: [
          {
            name: 'Insert Order',
            pathname: '/insert-order'
          },
          {
            name: 'Insert Return',
            pathname: '/insert-return'
          }
        ]
      },
      {
        parent: 'Tracking',
        pathname: '/tracking',
        children: [
          {
            name: 'By Order Number',
            pathname: '/search-tracking-info-by-order-number'
          },
          {
            name: 'By External',
            pathname: '/search-tracking-info-by-external-tracking'
          },
          {
            name: 'By AWB',
            pathname: '/search-tracking-info-by-number'
          }
        ]
      },
      {
        parent: 'In Hub',
        pathname: '/hub',
        children: [
          {
            name: 'Get package position',
            pathname: '/get-trck-nmr-fol-actual-position-dest'
          },
          {
            name: 'Get all position',
            pathname: '/search-grid-position-destination-by-hub'
          }
        ]
      }
    ]
  },
  {
    api: 'Files',
    pathname: '/customer/files',
    content: [
      {
        parent: 'Shipment',
        pathname: '/shipment',
        children: [
          {
            name: 'Upload File',
            pathname: '/upload-file'
          },
          {
            name: 'Response',
            pathname: '/ok'
          },
          {
            name: 'Error Response',
            pathname: '/error'
          }
        ]
      },
      {
        parent: 'Hub Pre-Manifest',
        pathname: '/hub-pre-manifest',
        children: [
          {
            name: 'Upload File',
            pathname: '/upload-file'
          },
          {
            name: 'Response',
            pathname: '/ok'
          },
          {
            name: 'Error Response',
            pathname: '/error'
          }
        ]
      },
      {
        parent: 'Manifest',
        pathname: '/manifest',
        children: [
          {
            name: 'Upload File',
            pathname: '/upload-file'
          },
          {
            name: 'Response',
            pathname: '/ok'
          },
          {
            name: 'Error Response',
            pathname: '/error'
          }
        ]
      }
    ]
  },
  {
    api: 'API SkyPostal Customer 2.0',
    pathname: '/customer/api-skypostal',
    content: [
      {
        parent: 'Process',
        pathname: '/process',
        children: [
          {
            name: 'Diagram',
            pathname: '/process'
          }
        ]
      },
      {
        parent: 'Shipment',
        pathname: '/shipment',
        children: [
          // {
          //   name: 'Get Shipment Services',
          //   pathname: '/get-shipment-data-services'
          // },
          {
            name: 'New',
            pathname: '/new-shipment'
          },
          {
            name: 'Delete',
            pathname: '/delete-shipment'
          },
          {
            name: 'Update External Tracking',
            pathname: '/update-external-tracking'
          },
          {
            name: 'Update Harmonized Code',
            pathname: '/update-harmonized-code'
          },
          {
            name: 'Update Info',
            pathname: '/update-shipment'
          },
          {
            name: 'Update Info Release Hold',
            pathname: '/update-info-release-hold'
          },
          {
            name: 'Update Weights and Dims',
            pathname: '/update-shipment-weight-dims'
          },
          {
            name: 'Info And Tracking',
            pathname: '/info-and-tracking'
          }
        ]
      },
      {
        // parent: 'Manifest by Bag (Packet Included)',
        parent: 'Manifest',
        pathname: '/manifest-by-bag',
        children: [      
          {
            name: 'Create bag',
            pathname: '/create-bag'
          },
          {
            name: 'Create bag via hub',
            pathname: '/create-bag-via-hub'
          },
          {
            name: 'Create manifest',
            pathname: '/create-manifest'
          },
          {
            name: 'Create manifest via hub',
            pathname: '/create-manifest-via-hub'
          },
          {
            name: 'Get bag created',
            pathname: '/get-bag-created'
          },
          {
            name: 'Add Items To Closed Bag',
            pathname: '/add-items-to-closed-bag'
          },
          {
            name: 'Move Items Between Closed Bags',
            pathname: '/move-items-between-closed-bags'
          },
          {
            name: 'Remove Items From Closed Bags',
            pathname: '/remove-items-from-closed-bag'
          },
          {
            name: 'Manifest status',
            pathname: '/get-manifest-status'
          }
        ]
      },
      {
        // parent: 'Manifest by Bag (Packet Included)',
        parent: 'Pick Up',
        pathname: '/pick-up',
        children: [
          {
            name: 'Request Pick Up',
            pathname: '/request-pick-up'
          },
          {
            name: 'Status Request Pick Up',
            pathname: '/status-pick-up-request'
          },
          {
            name: 'Cancel Request Pick Up',
            pathname: '/cancel-pick-up-request'
          }
        ]
      },
      {
        parent: 'Hub Pre Manifest',
        pathname: '/hub-pre-alert',
        children: [
          {
            name: 'New',
            pathname: '/new-pre-alert'
          },
          {
            name: 'Delete Pre Alert',
            pathname: '/delete-pre-alert'
          },
          {
            name: 'Delete Pre Alert Items',
            pathname: '/delete-items'
          }
        ]
      },
      {
        parent: 'Tracking',
        pathname: '/tracking',
        children: [
          {
            name: 'By Skypostal Number',
            pathname: '/by-trck-nmr-fol'
          },
          {
            name: 'By External Number',
            pathname: '/by-external-tracking'
          },
          {
            name: 'By Tracking Number',
            pathname: '/by-tracking-number'
          },
          {
            name: 'Search',
            pathname: '/search'
          }
        ]
      },
      {
        parent: 'Geographic',
        pathname: '/geographic',
        children: [
          {
            name: 'Zip Code Verification',
            pathname: '/get-zipcode-verified'
          },
          {
            name: 'Zip Code Information',
            pathname: '/get-zipcode-info'
          }
        ]
      },
      {
        parent: 'Rate',
        pathname: '/rate',
        children: [
          {
            name: 'Get Shipment Rate',
            pathname: '/get-shipment-rate'
          }
        ]
      },
      {
        parent: 'Return',
        pathname: '/return',
        children: [
          {
            name: 'New',
            pathname: '/new-return'
          }
        ]
      },
      {
        parent: 'Reports',
        pathname: '/reports',
        children: [
          {
            name: 'Label exceptions and holds',
            pathname: '/get-label-exceptions-holds'
          }
        ]
      },
      {
        parent: 'Transit Times',
        pathname: '/transit-times',
        children: [
          {
            name: 'Get Services Transit Times',
            pathname: '/get-services-transit-times'
          }
        ]
      },
      {
        parent: '_________________________________',
        name: '.',
        style: '',
        children: []
      },
      {
        parent: 'Manifest (Deprecated)',
        pathname: '/manifest',
        children: [
          {
            name: 'New (Depreacted)',
            pathname: '/new-manifest'
          },
          {
            name: 'Status (Deprecated)',
            pathname: '/get-manifest-status'
          }
        ]
      }
      //
      // {
      //   parent: 'Process For Packet (Brazil Only)',
      //   pathname: '/manifest-for-packet',
      //   children: [
      //     {
      //       name: 'Diagram',
      //       pathname: '/packet-process'
      //     }
      //   ]
      // },
      // {
      //   parent: 'Manifest For Packet (Brazil Only)',
      //   pathname: '/manifest-for-packet',
      //   children: [
      //     {
      //       name: 'New Header',
      //       pathname: '/create-manifest'
      //     },
      //     {
      //       name: 'New Bag',
      //       pathname: '/create-bag'
      //     },
      //     {
      //       name: 'Add Item To Bag',
      //       pathname: '/add-item-to-bag'
      //     },
      //     {
      //       name: 'Remove Item From Bag',
      //       pathname: '/remove-item-from-bag'
      //     },
      //     {
      //       name: 'Close Bag',
      //       pathname: '/close-bag'
      //     },
      //     {
      //       name: 'Get Bag Info',
      //       pathname: '/packet-get-bag-info'
      //     },
      //     {
      //       name: 'Reopen Bag',
      //       pathname: '/reopen-bag'
      //     },
      //     {
      //       name: 'Cancel Bag',
      //       pathname: '/cancel-bag'
      //     },
      //     {
      //       name: 'Close',
      //       pathname: '/close-manifest'
      //     },
      //     {
      //       name: 'Get Manifest Status',
      //       pathname: '/get-manifest-status'
      //     }
      //     /*{
      //       name: 'Get Valid Airlines',
      //       pathname: '/get-valid-airlines'
      //     }*/
      //   ]
      // }
    ]
  },
  {
    api: 'API SkyPostal Provider 2.0',
    pathname: '/provider/api-skypostal',
    content: [
      {
        parent: 'Customs',
        pathname: '/customs',
        children: [
          {
            name: 'Insert Customs',
            pathname: '/insert-customs'
          },
          {
            name: 'Inform Payment Events',
            pathname: '/inform-payment-events'
          }
        ]
      },
      {
        parent: 'Clearance Partner',
        pathname: '/clearance',
        children: [
          {
            name: 'Invoices',
            pathname: '/invoices'
          }
        ]
      },
      {
        parent: 'Delivery Partner',
        pathname: '/delivery',
        children: [
          {
            name: 'Invoices',
            pathname: '/invoices'
          }
        ]
      },
      {
        parent: 'Reports',
        pathname: '/reports',
        children: [
          {
            name: 'Get Cleared Pending Pickup',
            pathname: '/get-cleared-pending-pickup'
          },
          {
            name: 'Search Invoices By Date',
            pathname: '/search-invoices-by-date'
          },
          {
            name: 'Search Shipment',
            pathname: '/search-shipment'
          },
          {
            name: 'Search Manifest',
            pathname: '/search-manifest'
          }
        ]
      },
      {
        parent: 'Shipment',
        pathname: '/shipment',
        children: [
          {
            name: 'Fee Payment Notification',
            pathname: '/payment-notification'
          },
          {
            name: 'New Dimensions',
            pathname: '/new-dimensions'
          },
          {
            name: 'New Weight',
            pathname: '/new-weight'
          }
        ]
      },
      {
        parent: 'Tracking',
        pathname: '/tracking',
        children: [
          {
            name: 'New Tracking',
            pathname: '/new-tracking'
          },
          {
            name: 'By Tracking Number',
            pathname: '/by-tracking-number'
          }
        ]
      }
    ]
  },
  {
    api: 'Files',
    pathname: '/provider/files',
    content: [
      {
        parent: '',
        pathname: '',
        children: [
          {
            name: 'Customs File',
            pathname: '/customs-file'
          },
          {
            name: 'Clearance Invoice File',
            pathname: '/clearance-file'
          },
          {
            name: 'Delivery Invoice File',
            pathname: '/delivery-file'
          }
        ]
      }
    ]
  }
]

export default routes
